<template>
  <v-dialog
    v-model="modalData.dialog"
    max-width="1650px"
    persistent
    scrollable
    key="transferModalkey"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="permissionCan('create')"
        color="primary"
        dark
        class="mb-2"
        v-bind="attrs"
        v-on="on"
        @click="$emit('new')"
      >
        New transfer
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <span class="headline">{{ formTitle }} </span>
            <v-btn
              @click="handleCloseModalForm"
              style="float: right; cursor: pointer"
              icon
              color="#26223c"
            >
              <v-icon> mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="3" md="3">
            <v-select
              v-if="statuses.stock"
              v-model="formModel.status"
              :items="statuses.stock.transfer"
              label="Status"
              item-text="value"
              item-value="key"
              disabled
            />
          </v-col>
        </v-row>

        <v-container>
          <ReleaseModalForm
            ref="releasetransferlist"
            key="transferModalReleasekey"
            :releaseModalData="Object.assign({}, releaseModalData)"
            :receivedData="{
              storage_id: formModel.source_storage_id,
              trNumber: formModel.tr_number,
            }"
            @closeModalForm="handleCloseReleaseModalForm"
            @saveModalForm="handleSaveReleaseModalForm"
            @new="handleNew"
          ></ReleaseModalForm>

          <ReceiveModalForm
            ref="receivetransferlist"
            key="transferModalReceivekey"
            :receiveModalData="Object.assign({}, receiveModalData)"
            :receivedData="{
              storage_id: formModel.destination_storage_id,
              trNumber: formModel.tr_number,
            }"
            @closeModalForm="handleCloseReceiveModalForm"
            @saveModalForm="handleSaveReceiveModalForm"
            @new="handleNew"
          ></ReceiveModalForm>

          <v-form v-model="formValid" ref="form">
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-btn
                  v-if="
                    permissionCan('create') &&
                    !formModel.id &&
                    permissionCan('update')
                  "
                  color="primary"
                  dark
                  class="mb-2"
                  @click="handleSaveModalForm"
                >
                  Save
                </v-btn>
                <v-btn
                  v-if="
                    permissionCan('create') &&
                    formModel.id &&
                    formModel.status != 10 &&
                    permissionCan('update')
                  "
                  color="primary"
                  dark
                  class="mb-2"
                  @click="handleSaveModalForm"
                >
                  Close
                </v-btn>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <div v-if="formModel.owner_name">
                  <p>User: {{ formModel.owner_name }}</p>
                  <p>Created at: {{ formModel.created_at }}</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" sm="5" md="5">
                <v-select
                  v-model="formModel.source_storage_id"
                  :items="storageCollectionAll"
                  :rules="requiredRules"
                  label="Select source storage"
                  item-text="name"
                  item-value="id"
                  :id="dynamicID"
                  :error-messages="messages['source_storage_id']"
                  @keyup="messages['source_storage_id'] = ''"
                  :disabled="formModel.entities.length > 0 || formModel.id"
                />
                <label for="datepicker-scheduled_release_date"
                  >Select release date</label
                >
                <b-form-datepicker
                  id="datepicker-scheduled_release_date"
                  v-model="formModel.scheduled_release_date"
                  calendar-width="100%"
                  locale="en"
                  class="mb-2"
                  start-weekday="1"
                  :disabled="formModel.id || !formModel.source_storage_id"
                  :error-messages="messages['scheduled_release_date']"
                  @input="messages['scheduled_release_date'] = ''"
                ></b-form-datepicker>
                <span style="color: red">{{
                  messages["scheduled_release_date"]
                }}</span>

                <v-btn
                  v-if="(permissionCan('create') || 1) && formModel.id"
                  color="primary"
                  dark
                  class="mb-2"
                  @click="releaseModalData.dialog = true"
                >
                  <!-- @click="handleSaveModalForm" -->
                  Release
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-divider vertical></v-divider>
              <v-spacer></v-spacer>

              <v-col cols="5" sm="5" md="5">
                <v-select
                  v-model="formModel.destination_storage_id"
                  :items="destinationStorageCollection"
                  :rules="requiredRules"
                  label="Select destination storage"
                  item-text="name"
                  item-value="id"
                  :id="dynamicID"
                  :error-messages="messages['destination_storage_id']"
                  @input="messages['destination_storage_id'] = ''"
                  :disabled="formModel.id"
                />
                <label for="datepicker-scheduled_receive_date"
                  >Select receive date</label
                >
                <b-form-datepicker
                  id="datepicker-scheduled_receive_date"
                  v-model="formModel.scheduled_receive_date"
                  calendar-width="100%"
                  locale="en"
                  class="mb-2"
                  start-weekday="1"
                  :disabled="
                    formModel.id ||
                    !formModel.source_storage_id ||
                    !formModel.destination_storage_id
                  "
                  :error-messages="messages['scheduled_receive_date']"
                  @keyup="messages['scheduled_receive_date'] = ''"
                ></b-form-datepicker>
                <span style="color: red">{{
                  messages["scheduled_receive_date"]
                }}</span>
                <v-btn
                  v-if="(permissionCan('create') || 1) && formModel.id"
                  color="primary"
                  dark
                  class="mb-2"
                  @click="receiveModalData.dialog = true"
                >
                  Receive
                </v-btn>
              </v-col>
            </v-row>

            <v-form v-model="formItemValid" ref="formItem">
              <v-row>
                <v-col cols="2" sm="2" md="3">
                  <v-combobox
                    v-if="!formModel.id && formModel.source_storage_id"
                    :items="itemCollection"
                    v-model="itemInputData.item"
                    item-text="ReferenceName"
                    :label="searchInpuText"
                    :return-object="true"
                    :disabled="isEditedItemData"
                    :error-messages="messages['item']"
                    @input="handleInputItemSearch"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No item matching! Press <kbd>enter</kbd> to search
                            serial number
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
              <row v-if="entitySelected">
                <v-col cols="12" sm="12" md="12">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Reference</th>
                          <th>Item name</th>
                          <th>Serial number</th>
                          <th>Quantity</th>
                          <th>Quantity unit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ entitySelected.item_entity_id }}</td>
                          <td>{{ entitySelected.reference_number }}</td>
                          <td>{{ entitySelected.nameTranslated }}</td>
                          <td>{{ entitySelected.serial_number }}</td>
                          <td>{{ entitySelected.quantity }}</td>
                          <td>{{ entitySelected.quantityUnitTranslated }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </row>
            </v-form>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-data-table
                  :headers="headers"
                  :items="formModel.entities"
                  class="elevation-1"
                  group-by="Pcs"
                  show-group-by
                  :items-per-page="5"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                    itemsPerPageOptions: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, -1]
                  }"
                >
                  <template
                    v-slot:group.header="{ group, headers, toggle, isOpen }"
                  >
                    <td :colspan="headers.length">
                      <v-btn
                        @click="toggle"
                        small
                        icon
                        :ref="group"
                        :data-open="isOpen"
                      >
                        <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down</v-icon>
                      </v-btn>
                      {{ group }}
                    </td>
                  </template>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Entities</v-toolbar-title>
                      <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
                      <v-spacer></v-spacer>

                      <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                          <v-card-title class="text-h5"
                            >Are you sure you want to delete this
                            item?</v-card-title
                          >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="closeDelete"
                              >Cancel</v-btn
                            >
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="deleteItemConfirm"
                              >OK</v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.name="{ item }">
                    <!-- <span> {{ item.item.name }}</span> -->
                    <span> {{ item.nameTranslated }}</span>
                  </template>

                  <template v-slot:item.reference="{ item }">
                    <!-- <span> {{ item.item.reference }}</span> -->
                    <span> {{ item.reference_number }}</span>
                  </template>

                  <template v-slot:item.quantityUnit="{ item }">
                    <!-- <span> {{ item.item.quantityUnit }}</span> -->
                    <span> {{ item.quantityUnitTranslated }}</span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <!-- <v-icon
                      v-if="!formModel.id"
                      :disabled="itemInputData.item_id"
                      small
                      class="mr-2"
                      @click="handleClickEntity(item)"
                    >
                      mdi-pencil
                    </v-icon> -->
                    <v-icon
                      small
                      @click="deleteItem(item)"
                      v-if="!formModel.id"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <span
                  v-if="messages['entities'] && messages['entities'].length > 0"
                  style="color: red"
                  >{{ messages["entities"] }}</span
                >
              </v-col>
            </v-row>
            <row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  :disabled="formModel.id"
                  v-model="formModel.comment"
                  label="Comment"
                />
              </v-col>
            </row>
            <!-- <pre>
            {{ formModel }}
            </pre> -->
          </v-form>
          <!-- *******************
Etity dialog
*******************-->

          <v-dialog v-model="entityModal" persistent max-width="1200px">
            <v-card>
              <v-card-title>
                <v-toolbar flat dense>
                  <v-toolbar-title>Select entity</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="entityModal = false"
                    style="float: right; cursor: pointer"
                    icon
                    color="#26223c"
                  >
                    <v-icon> mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-text-field
                    v-model="searchEntity"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-data-table
                        :headers="headersEntity"
                        :items="entitiesArray"
                        :search="searchEntity"
                        v-model="selectedEntities"
                        item-key="item_entity_id"
                        show-select
                        class="elevation-1"
                        @click:row="handleClickItem"
                        :items-per-page="5"
                        :footer-props="{
                          showFirstLastPage: true,
                          firstIcon: 'mdi-arrow-collapse-left',
                          lastIcon: 'mdi-arrow-collapse-right',
                          prevIcon: 'mdi-minus',
                          nextIcon: 'mdi-plus',
                          itemsPerPageOptions: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, -1]
                        }"
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="entityModal = false">
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="handleAddToListSelected"
                  >Add to list</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="handleCloseModalForm">
          Cancel
        </v-btn>
        <v-btn
          v-if="
            (permissionCan('create') && !formModel.id) ||
            permissionCan('update')
          "
          color="blue darken-1"
          text
          @click="handleSaveModalForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { ENDPOINT } from "./Transfers";
import i18nService from "@/core/services/i18n.service.js";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import ReleaseModalForm, {
  initialReleaseFormData,
} from "../releases/ReleaseModalForm";

import ReceiveModalForm, {
  initialReceiveFormData,
} from "../receives/ReceiveModalForm";

const TRANSLATED_ATRIBUTES = [];

var today = new Date();
var dd = today.getDate();

var mm = today.getMonth() + 1;
var yyyy = today.getFullYear();
if (dd < 10) {
  dd = "0" + dd;
}

if (mm < 10) {
  mm = "0" + mm;
}
today = yyyy + "-" + mm + "-" + dd;

export const initialFormData = () => ({
  id: null,
  status: 0,
  source_storage_id: null,
  destination_storage_id: null,
  scheduled_release_date: null,
  scheduled_receive_date: null,
  comment: "",
  owner_id: null,
  owner_name: null,
  created_at: null,
  entities: [],
});

export const initialItemInputData = {
  item_entity_id: null,
  item: null,
  quantityUnit: null,
  serial_number: null,
  quantity: null,
  old_status: null,
};

export default {
  name: "TransferForm",
  props: ["modalData"/* , "permissions" */],
  components: { ReleaseModalForm, ReceiveModalForm },
  data() {
    return {
      loader: false,
      languages: i18nService.languages,
      selectedLocale: i18nService.languages.find((item) => {
        return item.lang == i18nService.getActiveLanguage();
      }),
      formModel: Object.assign({}, initialFormData()),
      formValid: false,
      releaseModalData: {
        dialog: false,
        editedId: null,
      },
      receiveModalData: {
        dialog: false,
        editedId: null,
      },
      initialReleaseFormData: Object.assign({}, initialReleaseFormData()),
      initialReceiveFormData: Object.assign({}, initialReceiveFormData()),
      formItemValid: false,
      itemInputData: Object.assign({}, initialItemInputData),
      editedItem: Object.assign({}, initialItemInputData),
      editedIndex: null,
      dialogDelete: false,
      entityModal: false,
      entitySelected: null,
      entitiesArray: [],
      selectedEntities: [],
      cancelItem: null,
      searchEntity: "",
      permissions: [],
      headersEntity: [
        { text: "ID", value: "item_entity_id" },
        { text: "Reference", value: "reference_number" },
        { text: "Item name", value: "nameTranslated" },
        { text: "Serial number", value: "serial_number" },
        { text: "Status", value: "statusTranslated" },
        { text: "Original quantity", value: "original_quantity" },
        { text: "Quantity", value: "quantity" },
        { text: "Quantity unit", value: "quantityUnitTranslated" },
        { text: "Storage", value: "storage" },
        { text: "Reserved at", value: "reserved_at" },
        { text: "Reserved by", value: "reserved_by_name" },
      ],

      headers: [
        { text: "Pcs", value: "Pcs" },
        { text: "ID", value: "item_entity_id", groupable: false },
        // { text: "Type of adjustment", value: "typeOf" },
        { text: "Reference", value: "reference", groupable: false },
        { text: "Item name", value: "name", groupable: false },
        { text: "Serial number", value: "serial_number", groupable: false },
        { text: "Quantity", value: "quantity", groupable: false },
        // { text: "Original quantity", value: "original_quantity" },
        { text: "Quantity unit", value: "quantityUnit", groupable: false },
        { text: "Old state", value: "oldStatusTranslated", groupable: false },
        { text: "Action", value: "actions", groupable: false },
      ],

      messages: {},
      stringRules: [
        (v) => !!v || "Field is required",
        (v) => v.length < 25 || "Field must be max 16 characters",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
    };
  },
  computed: {
    ...mapGetters([
      "statuses",
      "types",
      "itemCollection",
      "storageCollectionAll",
    ]),

    destinationStorageCollection() {
      if (!this.storageCollectionAll) {
        return [];
      }
      if (!this.formModel.source_storage_id) return this.storageCollectionAll;

      return this.storageCollectionAll.filter((item) => {
        return item.id != this.formModel.source_storage_id;
      });
    },
    // adjustmentStatuses() {
    //   if (this.statuses) {
    //     let statuses = this.statuses;

    //     this.statuses.stock["receive_itemEntity"].map((item) => {
    //       item.translated = this.getTranslatedStatus(item.key);
    //       return item;
    //     });
    //     return statuses;
    //   }
    //   return [];
    // },

    statusesEdit() {
      return this.statuses.stock.itemEntity;
    },

    dynamicID() {
      let text = "dynamicID";
      let chars = "abcdefghijklmnopqrstuvwxyz";

      for (let i = 0; i < 10; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return text;
    },

    formTitle() {
      return this.formModel.id
        ? "View transfer" + " - " + this.formModel.tr_number
        : "New transfer";
    },

    searchInpuText() {
      return "Search entity: reference, item name, project, so";
    },
  },

  watch: {
    "modalData.dialog": {
      handler(value) {
        if (value && !this.modalData.editedId) {
          this.itemInputData = Object.assign({}, initialItemInputData);
          this.formModel = Object.assign({}, initialFormData());
          this.formModel.scheduled_release_date = today;
          this.formModel.scheduled_receive_date = today;
        }
        setTimeout(this.resetErrorMessages(), 1200, this.resetErrorMessages());
      },
      deep: true,
    },

    "modalData.editedId": {
      handler(value) {
        console.log("modalData.editedId");
        this.selectedLocale = i18nService.languages.find((item) => {
          return item.lang == i18nService.getActiveLanguage();
        });
        if (value) {
          ApiService.get(ENDPOINT + value)
            .then(({ data }) => {
              for (var entity of data.entities) {
                entity.item = this.$store.getters.getItemByID(entity.item_id);
                entity.item.reference_number = entity.reference_number;
                entity.item.serial_number = entity.serial_number;
                // entity.quantity = entity.quantity;
                entity.old_status = entity.status;
                entity.oldStatusTranslated = this.getTranslatedStatus(
                  entity.old_status
                );
                entity.status = 4;
                entity.statusTranslated = this.getTranslatedStatus(
                  entity.status
                );
                entity.nameTranslated = this.$helpers.getTranslated(
                  entity.translations
                ).name;
                entity.item.quantity_unit_id = entity.quantity_unit_id;
                // entity.item.comment = entity.comment;
                entity.quantityUnitTranslated =
                  this.$store.getters.getQuantityUnitByID(
                    entity.quantity_unit_id
                  ).name;
              }

              data.entities = this.calcEntityPcs(data.entities);
              this.formModel = Object.assign({}, data);
              this.setTranslatedAttributes();
              setTimeout(() => {
                this.closeAll();
              }, 200);
            })
            .catch((error) => {
              console.log("Error!: ", error);
            });
        }
        this.resetErrorMessages();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["fetchStorage", "fetchItem", "fetchQuantityUnit"]),
    handleCloseModalForm() {
      let data = this.formModel.entities.map((item) => {
        return item.item_entity_id;
      });

      if (!this.formModel.id && data.length > 0) {
        this.unReserveEntityByIds({
          ids: data,
        });
      }

      this.releaseModalData = {
        dialog: false,
        editedId: null,
      };
      this.receiveModalData = {
        dialog: false,
        editedId: null,
      };
      this.$emit("closeModalForm");
    },

    handleSaveModalForm() {
      if (this.formModel.id) {
        this.formModel.status = 10;
      }
      let model = Object.assign({}, this.formModel);

      this.$refs.form.validate();

      if (this.formValid) {
        this.resetErrorMessages();
        // this.modalData.loading = true;

        /**Delete unused translations */
        if (TRANSLATED_ATRIBUTES.length > 0) {
          let translations = {};
          i18nService.languages.forEach((item) => {
            let langCode = item.lang;
            if (
              model.translations[langCode] &&
              model.translations[langCode].name != ""
            ) {
              translations[langCode] = Object.assign(
                {},
                model.translations[langCode]
              );
            }
          });
          if (Object.keys(translations).length != 0) {
            model.translations = translations;
          }
        }
        /**Delete unused translations */
        this.loader = true;
        if (model.id) {
          ApiService.put(ENDPOINT + model.id, model)
            .then(() => {
              this.$emit("saveModalForm");
            })
            .catch((error) => {
              if (error.response) {
                let errors = error.response.data;
                if (errors) {
                  for (let field in errors) {
                    this.setError(field, errors[field][0]);
                  }
                }
              }
            })
            .finally(() => {
              this.loader = false;
            });
        } else {
          //create model
          ApiService.post(ENDPOINT, model)
            .then(() => {
              this.$emit("saveModalForm");
            })
            .catch((error) => {
              if (error.response) {
                let errors = error.response.data;
                if (errors) {
                  for (let field in errors) {
                    this.setError(field, errors[field][0]);
                  }
                }
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log("Error", error.message);
              }
              console.log("Error!: ", error);
            })
            .finally(() => {
              this.loader = false;
            });
        }
      }
    },

    handleInputItemSearch(value) {
      this.entitySelected = null;
      if (value && typeof value === "object") {
        this.openEntityModalForm({
          storage_id: this.formModel.source_storage_id,
          statuses: [0, 1, 2, 3, 4, 6, 7, 9],
          item_id: this.itemInputData.item.id,
        });
      } else if (value != "") {
        this.itemCollection = [];
        this.openEntityModalForm({
          s: value,
          storage_id: this.formModel.source_storage_id,
          statuses: [0, 1, 2, 3, 4, 6, 7, 9],
        });
      }
    },

    openEntityModalForm(searchObj) {
      ApiService.post(ENDPOINT + "itemEntity/search", searchObj)
        .then((data) => {
          if (data.data.length > 0) {
            let dataTranslated = data.data.map((item) => {
              item.nameTranslated = this.$helpers.getTranslated(
                item.translations
              ).name;
              item.quantityUnitTranslated = this.$helpers.getTranslated(
                item.quantity_unit_translations
              ).name;
              item.statusTranslated = this.getTranslatedStatus(item.status);
              item.isSelectable = !item.reserved_at;
              return item;
            });
            this.entitiesArray = dataTranslated;
            this.entityModal = true;
          } else {
            Swal.fire({
              title: "",
              text: "Entity not found!",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
    },

    handleClickEntity(entity) {
      this.unReserveEntityByIds({
        ids: [entity.item_entity_id],
      });
      this.itemInputData = Object.assign({}, entity);
      this.itemInputData.status = 4;

      let editedIndex = this.formModel.entities.indexOf(entity);
      this.cancelItem = Object.assign({}, entity);
      this.formModel.entities.splice(editedIndex, 1);
    },

    handleAddToListSelected() {
      let entityIds = this.selectedEntities.map((entity) => {
        return entity.item_entity_id;
      });

      if (this.selectedEntities.length > 0) {
        this.formModel.entities = this.calcEntityPcs([
          ...this.formModel.entities,
          ...this.selectedEntities.map((entity) => {
            entity.old_status = entity.status;
            entity.status = 4;
            entity.statusTranslated = this.getTranslatedStatus(entity.status);
            entity.oldStatusTranslated = this.getTranslatedStatus(
              entity.old_status
            );
            return entity;
          }),
        ]);

        this.reserveEntityByIds({
          ids: entityIds,
        });

        this.entityModal = false;
        this.cancelItem = null;
        this.itemInputData = Object.assign({}, initialItemInputData);
        this.selectedEntities = [];
        setTimeout(() => {
          this.closeAll();
        }, 200);
      }
    },

    handleCancelItem() {
      this.formModel.entities.push(this.cancelItem);
      this.itemInputData = Object.assign({}, initialItemInputData);
      this.reserveEntityByIds({
        ids: [this.cancelItem.item_entity_id],
      });
      this.cancelItem = null;
      this.$refs.formItem.resetValidation();
    },

    resetInpuDataForm() {
      this.entitiesArray = [];
      this.entitySelected = null;
      this.itemInputData = Object.assign({}, initialItemInputData);
    },

    getItemPcs(item) {
      return (
        " " +
        item.reference_number +
        " " +
        item.nameTranslated +
        " " +
        item.quantity +
        item.quantityUnitTranslated
      );
    },

    calcEntityPcs(entities) {
      if (!entities || typeof entities == "undefined") {
        return [];
      }
      let pcsArray = [];

      entities = entities.map((item) => {
        item.Pcs = this.getItemPcs(item);
        if (pcsArray.indexOf(item.Pcs) === -1) {
          pcsArray.push(item.Pcs);
        }
        return item;
      });

      pcsArray.forEach((pcs) => {
        let sum = 0;
        entities
          .filter((item) => {
            if (item.Pcs == pcs) sum++;
            return item.Pcs == pcs;
          })
          .map((item) => {
            item.Pcs = item.Pcs + " - " + sum + " pcs";
            return item;
          });
      });

      return entities;
    },

    closeAll() {
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },

    getTranslatedStatus(id) {
      return this.$t("ADJUSTMENT.status_" + id);
    },

    setTranslatedAttributes() {
      if (!this.formModel.id) {
        this.languages.forEach((language) => {
          TRANSLATED_ATRIBUTES.forEach((attribute) => {
            this.formModel.translations[language.lang] = {};
            this.formModel.translations[language.lang][attribute] = "";
          });
        });
      } else {
        this.languages.forEach((language) => {
          TRANSLATED_ATRIBUTES.forEach((attribute) => {
            if (!this.formModel.translations[language.lang]) {
              this.formModel.translations[language.lang] = {};
              this.formModel.translations[language.lang][attribute] = "";
            }
          });
        });
      }
    },

    handleAddItemToList() {
      this.$refs.formItem.validate();

      if (this.formItemValid) {
        let self = Object.assign({}, this);
        this.reserveEntityByIds({
          ids: [this.itemInputData.item_entity_id],
        }).then((data) => {
          if (data) {
            self.formModel.entities.push(self.itemInputData);
            self.itemInputData = Object.assign({}, initialItemInputData);
          } else {
            Swal.fire({
              title: "",
              text: "The entity is reserved!",
              icon: "error",
            });
          }
        });

        this.entitySelected = null;
        this.itemInputData = Object.assign({}, initialItemInputData);
        this.$refs.formItem.resetValidation();
      }
    },

    resetItemInputData() {
      this.itemInputData.item = null;
      this.itemInputData.quantityUnit = null;
      this.itemInputData.serial_number = null;
      this.itemInputData.quantity = null;
      this.itemInputData.status = null;
      this.itemInputData.old_status = null;
      this.cancelItem = null;
    },

    reserveEntityByIds(entityIds) {
      return ApiService.post(ENDPOINT + "itemEntity/reserve", entityIds);
    },

    unReserveEntityByIds(entityIds) {
      ApiService.post(ENDPOINT + "itemEntity/unreserve", entityIds)
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
    },

    deleteItem(item) {
      this.editedIndex = this.formModel.entities.indexOf(item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      let itemToDelete = this.formModel.entities[this.editedIndex];

      this.unReserveEntityByIds({
        ids: [itemToDelete.item_entity_id],
      });

      this.formModel.entities.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = null;
      });
    },

    handleSaveReleaseModalForm() {
      this.handleCloseReleaseModalForm();
    },

    handleCloseReleaseModalForm() {
      this.releaseModalData.dialog = false;
      this.releaseModalData.editedId = null;
      // this.fetchTransfer();
    },

    handleSaveReceiveModalForm() {
      this.handleCloseReceiveModalForm();
    },

    handleCloseReceiveModalForm() {
      this.receiveModalData.dialog = false;
      this.receiveModalData.editedId = null;
    },

    handleClickItem(item) {
      if (this.permissionCan("view") && !this.dialogDelete) {
        this.$router.push(`/stock/transfers/${item.id}`);
      }
    },

    resetErrorMessages() {
      let errorData = Object.assign({}, initialFormData());

      if (this.$refs.form) this.$refs.form.resetValidation();

      this.languages.forEach((language) => {
        TRANSLATED_ATRIBUTES.forEach((attribute) => {
          errorData["translations." + language.lang + "." + attribute] = "";
        });
      });
      this.messages = errorData;
    },

    setError(prop, value) {
      this.messages[prop] = value;
    },

    setPermissions() {
      if (localStorage.permissions) {
        this.permissions = JSON.parse(localStorage.permissions).filter(
          (item) => item.name.indexOf("transfer") > -1
        );
      }
    },

    permissionCan(action) {
      return this.permissions.find((x) => x.name == "stock.transfer." + action);
    },
  },

  async mounted() {
    this.fetchItem();
    this.fetchStorage();
    this.fetchQuantityUnit();
    this.setTranslatedAttributes();
    this.setPermissions();
  },
};
</script>
